import { diffWords } from 'diff';

/**
 
 *
 * @param {string} oldValue - Original text (initial version)
 * @param {string} newValue - Updated text (current version)
 * @returns {string} HTML markup with only the differences, or an empty string if no differences.
 */
export const renderTextDiffToHtml = (oldValue = '', newValue = '') => {
  const hasValues = Boolean(oldValue?.trim()?.length || newValue?.trim()?.length);

  if (!hasValues) {
    return '';
  }

   const normalizedOld = (oldValue || '').trim().replace(/\s+/g, ' ');
  const normalizedNew = (newValue || '').trim().replace(/\s+/g, ' ');

   if (normalizedOld === normalizedNew) {
    return '';
  }

  try {
     const diff = diffWords(normalizedOld, normalizedNew);
    
    const removedParts = [];
    const addedParts = [];

    diff.forEach((part) => {
      if (part.removed) {
        removedParts.push(part.value.trim());
      } else if (part.added) {
        addedParts.push(part.value.trim());
      }
    });

     if (removedParts.length === 0 && addedParts.length === 0) {
      return '';
    }

     let html = '<div class="gap-text-diff">';
    
    if (removedParts.length > 0) {
      html += '<div class="diff-removed"><span class="diff-marker">-</span> ';
      html += removedParts.join(' ').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      html += '</div>';
    }
    
    if (addedParts.length > 0) {
      html += '<div class="diff-added"><span class="diff-marker">+</span> ';
      html += addedParts.join(' ').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      html += '</div>';
    }
    
    html += '</div>';

    return html;
  } catch (error) {
    console.error('[renderTextDiffToHtml] Failed to build diff output', error);
    return '';
  }
};

